/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partner_Referral_Delete_BlockedInputs */



/**
* | output |
* | --- |
* | "Codes with attributed customers cannot be deleted — deactivate instead." |
*
* @param {Partner_Referral_Delete_BlockedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_referral_delete_blocked = /** @type {((inputs?: Partner_Referral_Delete_BlockedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Referral_Delete_BlockedInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Codes mit zugeordneten Kunden können nicht gelöscht werden – stattdessen deaktivieren.")
	return /** @type {LocalizedString} */ ("Codes with attributed customers cannot be deleted — deactivate instead.")
});